import type { SpaceType } from "@circle-react/types/Space";

import { t } from "@/i18n-js/instance";

export type PostNotificationSpaceType = Exclude<
  SpaceType,
  "chat" | "course" | "members"
>;

export interface NotificationOption {
  description: string;
  label: string;
  value: string;
}

export const buildNotificationOptions = (
  postType: PostNotificationSpaceType,
): NotificationOption[] => [
  {
    label: t("spaces.form.create.notification_types.email"),
    description: t(
      `spaces.form.create.notification_by_space_type.${postType}.email_description`,
    ),
    value: "default_notification_setting",
  },
  {
    label: t("spaces.form.create.notification_types.inapp"),
    description: t(
      `spaces.form.create.notification_by_space_type.${postType}.inapp_description`,
    ),
    value: "default_in_app_notification_setting",
  },
  {
    label: t("spaces.form.create.notification_types.mobile"),
    description: t(
      `spaces.form.create.notification_by_space_type.${postType}.mobile_description`,
    ),
    value: "default_mobile_notification_setting",
  },
];
